import Header from "../components/Header";
import { webapp, webdes, cloud } from "../assets/icons/index";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import {
  ABOUT_PATH,
  CLOUDHOSTING_PATH,
  SERVICES_PATH,
  WEBAPPDEV_PATH,
  WEBDESIGN_PATH,
} from "../Routes/paths";
import Contact from "../components/Contact";

interface HomeProps {}

const Home = ({}: HomeProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        } `}
      >
        {/* hero section  *********************************/}
        <section className="my-[80px] px-[20px] lg:px-0 w-full  bg-hero bg-cover  flex flex-col justify-center gap-14 lg:gap-0 lg:flex-row lg:items-center lg:justify-around">
          <div
            className={`text-center ${
              i18n.language === "en" ? "lg:text-left" : "lg:text-right"
            } `}
          >
            <div className=" font-[700] text-[20px] lg:text-[40px]">
              <p className="inline-block border-b-8 border-second_color">
                {t("Innovative Solutions")}
              </p>
              <p>{t("Beyond Software")}</p>
            </div>
            <p className="max-w-[440px] lg:text-[20px]">
              {t(
                "Your Partner in Digital Excellence, Efficiency, and Transformation"
              )}
            </p>
          </div>

          <div>
            <img className="" src="../images/heroperson.png" alt="" />
          </div>
        </section>

        {/* next section  **********************************/}
        <section className="my-[50px] px-[20px] lg:px-0 w-full h-[610px]  flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around">
          <div>
            <img src="../images/herobg2.png" alt="" />
          </div>

          <div
            className={`flex flex-col gap-3 text-center ${
              i18n.language === "en" ? "lg:text-left" : "lg:text-right"
            }`}
          >
            <p className="max-w-[433px] text-[20px] lg:text-[28px] font-[700]">
              {t("Pioneering the Future of Technology and Innovation")}
            </p>
            <p className="max-w-[503px] lg:text-[14px] font-[400]">
              {t(
                "explores cutting-edge advancements and inventive strategies transcending traditional software boundaries. This title delves into breakthrough technologies, creative problem-solving approaches, and forward-thinking methodologies that redefine the future of tech industries and business innovation. Discover how visionary ideas are transforming tomorrow's digital landscape."
              )}
            </p>
            <div className="w-full flex justify-center lg:justify-start">
              <button
                onClick={() => navigate(`${ABOUT_PATH}`)}
                className="w-[136px] h-[40px] rounded-[12px] bg-[#E4002F] text-white lg:text-[14px]"
              >
                {t("Know More")}
              </button>
            </div>
          </div>
        </section>

        {/* Our Services ***********************************/}
        <section className="my-[100px] px-[20px] lg:px-0 w-full flex flex-col gap-10 ">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Our Services")}
          </p>
          <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
            <div
              onClick={() => navigate(`${WEBDESIGN_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={webdes} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Web Design")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Website design that is cost effective, of an international quality and easy to browse."
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${CLOUDHOSTING_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={cloud} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Cloud Hosting")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Designed to meet the diverse needs of businesses of all sizes with good prices"
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${WEBAPPDEV_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={webapp} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Web Application Development")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center ">
                {t(
                  "Custom built web application development, latest technologies at optimal rates."
                )}
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button
              onClick={() => navigate(`${SERVICES_PATH}`)}
              className="w-[200px] h-[40px] rounded-[12px] bg-[#E4002F] text-white lg:text-[14px]"
            >
              {t("See More Services")}
            </button>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default Home;
